enum GridArea {
  FOOTER = 'footer',
  HEADER = 'header',
  MAIN = 'main',
}

export { GridArea };
